// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import NewRoofsPage from "../pages/NewRoofs/NewRoofs";
const __wvcRoutePaths = ["/NewRoofsPage", "/new-roofs"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["chimneys", "chimneyspage", "fascias-soffits", "fasciassoffitspage", "flat-roofs", "flatroofspage", "gallery", "gallerypage", "get-in-touch", "getintouchpage", "guttering", "gutteringpage", "home", "homepage", "lead-work", "leadworkpage", "new-roofs", "newroofspage", "our-craft", "ourcraftpage", "post", "privacy-policy", "privacypolicypage", "repointing", "repointingservicespage", "roof-cleaning", "roofcleaningpage", "roofing-services", "roofingservicespage", "services-hub", "serviceshubpage", "terms-of-service", "termsofservicepage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<NewRoofsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<NewRoofsPage />} />
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
